// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-form-company-data .vert-form-item.vert-template-marketplace,
.container-form-personal-data .vert-form-item.vert-template-marketplace,
.container-form-address-personal .vert-form-item.vert-template-marketplace {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Profile/Profile.less"],"names":[],"mappings":"AAAA;;;EAII,gBAAA;AAAJ","sourcesContent":[".container-form-company-data,\n.container-form-personal-data,\n.container-form-address-personal {\n  .vert-form-item.vert-template-marketplace {\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
